// extracted by mini-css-extract-plugin
export default {"input__search":"SearchPage_input__search__e34E+"};